class JatkaCategoryLinks extends HTMLElement {
  connectedCallback() {
    this.rail = this.querySelector('nav');
    this.button = this.querySelector('button');
    if (!this.rail || !this.button) return;
    this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    this.update = () => {
      this.button.hidden = this.rail.scrollWidth <= this.rail.clientWidth + 2;
      const atEnd = this.rail.scrollLeft + this.rail.clientWidth >= this.rail.scrollWidth - 2;
      this.button.querySelector('span').textContent = atEnd ? '←' : '→';
    };
    this.rail.addEventListener('scroll', this.update, { ...options, passive: true });
    this.button.addEventListener('click', () => {
      const atEnd = this.rail.scrollLeft + this.rail.clientWidth >= this.rail.scrollWidth - 2;
      this.rail.scrollTo({ left: atEnd ? 0 : this.rail.scrollLeft + this.rail.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }, options);
    this.observer = new ResizeObserver(this.update);
    this.observer.observe(this);
    this.update();
    document.fonts.ready.then(() => { if (this.isConnected) this.update(); });
  }
  disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
}
if (!customElements.get('jatka-category-links')) customElements.define('jatka-category-links', JatkaCategoryLinks);
